module.exports = __webpack_public_path__ + "static/media/box-data-error.21182b5e.svg";